const QAErrors = ({ exchangeRate, dutyRatesError }) => {
  const exchangeRateError = exchangeRate === 'ERROR';
  if (!exchangeRateError && !dutyRatesError) return null;

  return (
    <div className="alert alert-danger text-center" role="alert">
      <strong>The following errors have occurred:</strong>
      {exchangeRateError && <div>There was an error fetching exchange rate data.</div>}
      {dutyRatesError && <div>There was an error fetching the item duty rates.</div>}
      Please try again later.
    </div>
  );
};

export default QAErrors;
